const PATH_UNSAFE_NAME_CHARS = /[\\/]/g;
const CONTROL_CHARS = /[\0\r\n]/g;

export function normalizeStorageBoxNewFileName(name, kind) {
  const ext = kind === 'rich' ? '.html' : '.txt';
  let base = String(name || '')
    .trim()
    .replace(CONTROL_CHARS, '')
    .replace(PATH_UNSAFE_NAME_CHARS, '_')
    .replace(/\s+/g, ' ');
  if (!base) {
    base = kind === 'rich' ? 'Untitled document' : 'Untitled';
  }
  if (!/\.[^./\\]+$/i.test(base)) {
    base += ext;
  } else if (kind === 'rich' && !/\.html?$/i.test(base)) {
    base = `${base.replace(/\.[^./\\]+$/i, '')}${ext}`;
  } else if (kind === 'plain' && !/\.(txt|md)$/i.test(base)) {
    base = `${base.replace(/\.[^./\\]+$/i, '')}${ext}`;
  }
  return base.slice(0, 240);
}

export function storageBoxFileFromEditorPayload(payload, kind, fileName) {
  let content = '';
  let mimeType = 'text/plain;charset=utf-8';

  if (kind === 'rich') {
    const html = payload?.html || '';
    mimeType = 'text/html;charset=utf-8';
    content = html;
  } else {
    content = payload?.markdown || '';
  }

  const blob = new Blob([content], { type: mimeType });
  return new File([blob], fileName, { type: mimeType });
}
